import clsx from 'clsx'

import { CmsSellerFilters, CustomCmsSeller } from '../../../domain/seller'

import { SellerItem } from './SellerItem'

type ListSellersByTypeProps = {
  sellers: CustomCmsSeller[]
  title: string
  filters?: CmsSellerFilters
  selectedStore?: CustomCmsSeller
  onSelectStore: (seller: CustomCmsSeller) => void
}

export const ListSellersByType = ({
  sellers,
  title,
  filters,
  selectedStore,
  onSelectStore,
}: ListSellersByTypeProps) => (
  <div className='map-list-sellers-bytype'>
    <h1 className='map-list-sellers-bytype-title'>{title}</h1>
    <ul className='map-list-sellers-bytype-list'>
      {sellers.map((seller) => (
        <div
          className={clsx('map-list-sellers-bytype-item-container', {
            active: selectedStore?.id === seller.id,
          })}
          data-seller-id={seller.id}
          key={seller.id}
          onClick={() => {
            if (selectedStore?.id !== seller.id) {
              onSelectStore(seller)
            }
          }}>
          <SellerItem seller={seller} filters={filters} />
        </div>
      ))}
    </ul>
  </div>
)
